import { useContext } from "react"
import LocationContext from "./LocationContext"
export default _ => {
    const ctx = useContext(LocationContext)
    const distance = ctx.distance
    return(
        <div className="fixed left-0 right-0 bottom-4 h-8 px-4 bold bg-red-400 text-white">Distance {distance}</div>
    )
}